// Ender dragon (M21.1). PURE (ENG-1): the boss's flight-phase cycle and the end
// crystal heal that keeps it alive. While any end crystal on the pillars is intact
// the dragon regenerates (and cannot be finished off); destroy them all and it
// becomes killable, dropping into a vulnerable perch at low health. On death it
// leaves the dragon egg.
import { DRAGON } from '../config';

export type DragonPhase = 'circling' | 'strafe' | 'perch' | 'charge';

/**
 * The dragon's current flight phase. With crystals still up it cycles circling →
 * strafe on the phase timer; with all crystals gone and its health low it drops to
 * a vulnerable perch; a close player during a strafe provokes a charge.
 */
export function dragonPhase(
  healthFraction: number,
  phaseTimer: number,
  crystalsAlive: number,
  playerClose = false,
): DragonPhase {
  if (crystalsAlive <= 0 && healthFraction <= DRAGON.PERCH_FRACTION) return 'perch';
  const cycle = ((phaseTimer % DRAGON.CYCLE_TICKS) + DRAGON.CYCLE_TICKS) % DRAGON.CYCLE_TICKS;
  if (cycle < DRAGON.CIRCLE_TICKS) return 'circling';
  return playerClose ? 'charge' : 'strafe';
}

/** HP the dragon regenerates per heal tick, one increment per intact crystal. */
export function crystalHeal(crystalsAlive: number): number {
  return crystalsAlive > 0 ? crystalsAlive * DRAGON.HEAL_PER_CRYSTAL : 0;
}

/** The dragon can only be finished off once every crystal is gone. */
export function dragonKillable(crystalsAlive: number): boolean {
  return crystalsAlive <= 0;
}

/** The dragon is most vulnerable (extra melee/attack damage lands) while perched. */
export function dragonPerched(phase: DragonPhase): boolean {
  return phase === 'perch';
}

/** Explosion damage an end crystal deals to whatever destroys/detonates it. */
export function crystalBlastDamage(): number {
  return DRAGON.CRYSTAL_BLAST;
}
